import { combineReducers } from 'redux';
import { regLoginReducer } from './regLogin';
import { userReducer } from './user';
import { onboardingReducer } from './onboarding';
/**
 * Condense distinct global reducers to single reducer
 * @param asyncReducers map of async reducers to load
 */
export const makeRootReducer = (asyncReducers) => combineReducers({
    // Add sync reducers here
    regLogin: regLoginReducer,
    user: userReducer,
    onboarding: onboardingReducer,
    ...asyncReducers,
});
